import fetch from 'isomorphic-fetch'

import { endpoint } from '@library/endpoint'

/**
 * @description Send event to clientmetrics-function /events endpoint
 * Uses isomorphic-fetch directly to avoid any custom logic
 */
export const sendClientMetricEvent = async (name: string, detail: Record<string, unknown>) => {
  try {
    await fetch(`${endpoint('clientmetrics')}/event`, {
      method: 'POST',
      body: JSON.stringify({
        name,
        time: new Date().toISOString(),
        client: 'web',
        detail,
      }),
      headers: {
        'content-type': 'application/json',
      },
    })
  } catch (e) {
    // ignore
  }
}
